<template>
    <on-click-outside :do="close">
        <div ref="filter" class="relative my-8 md:mt-0">
            <button @click.stop.prevent="switchPopper"
                    class="flex justify-between border border-main-text iphone-font-size pl-5 py-2 md:py-1 w-full text-center items-center outline-none text-grey-darkest lg:font-bold rounded">
                <p class="">{{options[selectedOption].name}}</p>
                <font-awesome-icon
                        :icon="['far', 'angle-down']"
                        fixed-width
                        class="arrow text-grey-dark cursor-pointer mr-3"
                ></font-awesome-icon>
            </button>
            <div ref="elements" v-show="showFilter" class="z-50 absolute bg-white border border-main-text rounded-lg w-full py-1 mt-2">
                <div class="w-full py-2  flex flex-row justify-between px-4 text-center cursor-pointer select-none font-medium selectedLabel"
                     v-for="(option, id, key) in filterOptions" :key="key" @click.prevent="changeOption(option.id, option.link)">
                    <button class="outline-none mr-8 no-underline lg:font-bold iphone-font-size text-md xl:text-lg text-main-text">
                        {{option.name}}
                    </button>
                    <img src="@/assets/SVG/tick.svg" alt="">
                </div>
                <div class="w-full py-2 flex flex-row justify-between px-4 text-center cursor-pointer select-none" v-if="user.role !== 'player'">
                    <a href="https://lk.mozgo.com" target="_blank" class="outline-none mr-8 no-underline lg:font-bold iphone-font-size text-md xl:text-lg text-main-text">
                        Лицензионный комплекс
                    </a>
                    <img src="@/assets/SVG/tick.svg" alt="">
                </div>
            </div>

        </div>
    </on-click-outside>
</template>

<script>
import Popper from 'popper.js';
import OnClickOutside from '../OnClickOutside';

export default {
  name: 'user-nav-mobile',
  components: { OnClickOutside },
  props: {
    options: {
      type: Object,
    },
  },
  data() {
    return {
      showFilter: null,
      hideSelectboxHandler: null,
      selectedOption: 0,
      a: [],

    };
  },
  created() {
    this.hideSelectboxHandler = () => {
      this.showFilter = false;
    };
  },
  watch: {
    showBox() {
      if (this.showFilter) {
        this.setupPopper();
        document.addEventListener('click', this.hideSelectboxHandler);
      } else {
        document.removeEventListener('click', this.hideSelectboxHandler);
      }
    },
  },
  beforeDestroy() {
    if (this.popper) {
      this.popper.destroy();
    }
  },
  computed: {
    user() {
      return this.$store.getters.userInfo;
    },
    filterOptions() {
      const teamFilter = [];
      for (let i = 0; i < Object.keys(this.options).length; i++) {
        if (this.options[i].type !== this.$route.name) {
          teamFilter.push({
            name: this.options[i].name, link: this.options[i].link, type: this.options[i].type, id: i,
          });
        }
        if (this.options[i].type === this.$route.name) {
          this.selectedOption = i;
        }
      }
      return teamFilter;
    },
  },
  methods: {
    close() {
      if (!this.showFilter) {
        return;
      }
      this.showFilter = false;
    },
    switchPopper() {
      this.$emit('closeOther');
      this.showFilter = !this.showFilter;
      if (this.showFilter) {
        this.$nextTick(() => {
          this.setupPopper();
        });
      }
    },
    changeOption(id, link) {
      this.selectedOption = id;
      this.showFilter = false;
      this.$router.push(`${link}`);
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.filter, this.$refs.elements, {
          placement: 'bottom',
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
  },
};
</script>

<style scoped lang="less">
    .selectedLabel {
        color: #333333;
        z-index: 50;
        &:hover {
            color: white;
            background-color: #BD006C;
        }
    }
    @media only screen and (min-width: 319px) and (max-width: 330px) {
        .iphone-font-size {
            font-size: .875rem !important;
        }
    }
</style>
